module.exports = __webpack_public_path__ + "img/njn.99fc79da.png";